import {getOlxRegionBasedOnLanguage, hasConsent} from "../../common/js/utils";
import {commonConfig} from "../../common/js/config";
import {
    setLandingBillingPeriod,
    setRadioAndUpdateSubscriptions,
    updateSubscriptions,
} from "./dom-manipulation";

export function handleEvents() {

    $("#slider-arrow-right").on("click", function (event) {
        const allVisibleCards = $('.step-slider-card.step-slider-card-visible');

        const firstVisibleCard = allVisibleCards.first();
        $("#slider-arrow-left").prop("disabled", false);

        if (allVisibleCards.length < 2) {
            $(this).prop("disabled", true);
        }

        // Удаляем класс, делающий элемент видимым, и добавляем класс начала анимации выхода
        firstVisibleCard.removeClass('step-slider-card-visible').addClass('step-slider-card-item-exit-done');

        // Отслеживаем завершение анимации


    });

    $("#slider-arrow-left").on("click", function (event) {

        const allExitCards = $('.step-slider-card.step-slider-card-item-exit-done');

        const lastExitCard = allExitCards.last();
        $("#slider-arrow-right").prop("disabled", false);

        if (allExitCards.length < 2) {
            $(this).prop("disabled", true);
        }

        // Удаляем класс, делающий элемент видимым, и добавляем класс начала анимации выхода
        lastExitCard.removeClass('step-slider-card-item-exit-done').addClass('step-slider-card-item-enter-active');

        // Отслеживаем завершение анимации
        lastExitCard.one('transitionend', function () {
            // По завершении анимации заменяем класс активной анимации на класс завершения анимации
            $(this).removeClass('step-slider-card-item-enter-active').addClass('step-slider-card-visible');
        });


    });

    $(".country-radio").on("change", function (event) {
        const country = $(this).data("country");
        updateSubscriptions(country);

        if (hasConsent(['functionality'])) {

            localStorage.setItem('userCountry', country);
        }


    });

    $("[data-landing-billing-period-toggle] [data-billing-period]").on("click", function () {
        setLandingBillingPeriod($(this).attr('data-billing-period'));
    });


}

export async function defineCountry() {
    // A country the visitor chose is kept only with functionality consent (see the .country-radio handler).
    // Otherwise the page language and the browser's languages decide. No location lookup: it prompted every
    // first-time visitor and sent their coordinates to a third party.
    const storedCountry = localStorage.getItem('userCountry');
    // The browser's region counts only for a country the page has a radio for.
    const offeredCountries = $('.country-radio').map((index, radio) => $(radio).data('country')).get();
    setRadioAndUpdateSubscriptions(storedCountry || getOlxRegionBasedOnLanguage(offeredCountries));
}
